import Icon from '../components/Icon';

const Merge = Icon(
  'merge',
  <>
    <path
      fillRule="evenodd"
      d="M2.75 2.25A.75.75 0 0 1 3.5 3v1.09c0 .53.146 1.196.406 1.943C5.1 9.46 8.848 11.25 12.75 11.25h7.44l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72h-7.44c-4.246 0-8.773-1.957-10.26-6.224C2.205 5.71 2 4.862 2 4.09V3a.75.75 0 0 1 .75-.75m4.118 11.048a.75.75 0 0 1-.193 1.043C5.084 15.435 3.5 17.608 3.5 19.911V21A.75.75 0 0 1 2 21v-1.09c0-2.939 1.96-5.523 3.825-6.805a.75.75 0 0 1 1.043.193"
      clipRule="evenodd"
    />
  </>
);

export default Merge;
